<template>
  <div class="menuBody" style="margin-left:25px;">
    <div class="menuTool" style="width:100%;">
         <InspectionClassificationDialog @dialogVisible="dialog" ref="InspectionClassificationDialog"/>
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                巡检分类列表
              <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" @click="PropertyAdd()">巡检分类添加</el-button>
            </div>
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入分类名称" size="small"    v-model="classifyName"></el-input>
              </div>
             <div style="float:right;margin-right:15px;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" @click="Inquire()">查询</el-button>
            </div>
    <el-table  :data="tableData" tooltip-effect="light"   v-loading="loading"    style="margin-bottom: 20px;overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column show-overflow-tooltip prop="id" label="分类序号"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="typeName" label="分类名称"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="分类描述" ></el-table-column>
        <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
            <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改"></el-button>
            <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除"  v-debounce></el-button>
            </template>
        </el-table-column>
    </el-table>
          <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import InspectionClassificationDialog from '../pollingCommon/InspectionClassificationDialog.vue'
export default {
  name: "InspectionClassification",
  components: {InspectionClassificationDialog},
  data() {
    return {
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        loading:false,
        classifyName:"",
        tableData:[],

    }
  },
  methods: {
    handleSizeChange(val) {
        this.pagesize  = val
        this.InitialQuery()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.InitialQuery()
    },
    InitialQuery(){
    // 列表
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "typeName":"",
      }
    this.$http.post(this.$requestUrl.POST_POLLING_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.tableData = data.data.records
        this.total = data.data.total
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })

    },
    dialog(data){
      if(data==false){
        this.InitialQuery()
      }
    },
    PropertyAdd(){
    // 添加
        let obj = {}
        this.$refs.InspectionClassificationDialog.title = "添加巡检分类";
        this.$refs.InspectionClassificationDialog.dialogVisible = true;
        this.$refs.InspectionClassificationDialog.formLabelAlign = obj
    },
    editMenu(row){
    // 修改
        this.$refs.InspectionClassificationDialog.title = "修改巡检分类";
        this.$refs.InspectionClassificationDialog.dialogVisible = true;
        this.$refs.InspectionClassificationDialog.formLabelAlign = row
    },
    delMenu(row){
    // 删除 DELETE_POST_POLLING
          this.$confirm('是否确认要删除该分类?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.get(this.$requestUrl.DELETE_POST_POLLING+row.id).then((res) => {
          let data = res.data
          if(data.code == 200){
            this.InitialQuery()
            }else{
              this.$message.error(data.msg)
            }
            })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    Inquire(){
    // 查询
       let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "typeName":this.classifyName,
      }
    this.$http.post(this.$requestUrl.POST_POLLING_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.tableData = data.data.records
        this.total = data.data.total
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
    },





  },
  mounted() {
      this.InitialQuery()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>